import reducer from './reducers';

export { default as configActions } from './actions';
export { default as configSagas } from './sagas';

export {
  auth0ConfigSelector,
  maxElapseTimeInMillisSelector,
  maxQuizAttemptsSelector,
  quizConfigSelector,
  stripeConfigSelector
} from './selectors';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/configuration/index.js